import React from 'react';
import { InstagramIcon, MailIcon, MapPinIcon, ClockIcon, PhoneIcon } from 'lucide-react';
const HOURS = [['Mon – Fri', '8:00 AM – 7:00 PM'], ['Saturday', '9:00 AM – 5:00 PM'], ['Sunday', 'Closed']];
export function Footer() {
  return <footer className="w-full bg-slate text-white" data-id="element-66" data-mp="32lrm3dfusxjz">
      <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8 sm:py-16" data-id="element-67" data-mp="36oo5h6d7wxoz">
        <div className="grid grid-cols-1 gap-10 sm:gap-12 lg:grid-cols-4" data-id="element-68" data-mp="3ufa3s5xf73ls">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-69" data-mp="38h5b9u0hiky">
            <a href="#home" className="flex items-center gap-2" data-id="element-70" data-mp="37fv17ktl04a">
              <img src="https://cdn.magicpatterns.com/uploads/iCSgMNo9mofRGomq3yMKNi/Logo_Ally_C.png" alt="Logo circular de Ally Cleaning Services" className="h-9 w-9 rounded-full object-contain" data-id="element-71" data-mp="3levgj10wbefn" />
              <span className="leading-tight" data-id="element-72" data-mp="2a19v9qy5pwze">
                <span className="block font-display font-extrabold tracking-tight text-lg" data-id="element-73" data-mp="2eyjrbpg1x6w7">
                  Ally
                </span>
                <span className="block text-[10px] uppercase tracking-[0.22em] text-white/50 -mt-0.5" data-id="element-74" data-mp="3l9sjt81pyyq2">
                  Cleaning Boutique
                </span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-white/60" data-id="element-75" data-mp="3v919hopjxr6m">
              Boutique, eco-friendly cleaning for discerning homes across
              Manhattan, Queens, and Long Island.
            </p>
            <div className="mt-5 flex gap-3" data-id="element-76" data-mp="80xkia4293k5">
              <a href="https://www.instagram.com/ally.cleaningservices" target="_blank" rel="noreferrer" aria-label="Visit Ally Cleaning Services on Instagram" className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 hover:bg-magenta transition-colors" data-id="element-77" data-mp="34pa1a0t5yjb">
                <InstagramIcon className="h-5 w-5" data-id="element-78" data-mp="mrwqdddihe01" />
              </a>
            </div>
          </div>

          {/* Hours */}
          <div data-id="element-79" data-mp="tvw5sbdtv5dc">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white/90" data-id="element-80" data-mp="tw618ehn64qf">
              <ClockIcon className="mr-2 inline h-4 w-4 text-sky-brand" data-id="element-81" data-mp="yv90tjeurir0" />
              Business Hours
            </h3>
            <ul className="mt-4 space-y-2 text-sm text-white/60" data-id="element-82" data-mp="13rpoydm1xx43">
              {HOURS.map(([day, time]) => <li key={day} className="flex justify-between gap-4" data-id="element-83" data-mp="18m3q6wneaygo">
                  <span data-id="element-84" data-mp="1ckt2elwp69yq">{day}</span>
                  <span className="text-white/80" data-id="element-85" data-mp="1cnyqbxtlb5sv">{time}</span>
                </li>)}
            </ul>
            <p className="mt-3 text-xs font-medium text-sky-brand" data-id="element-86" data-mp="1mjs9i01tdxjm">
              Yes — we&apos;re open Saturdays!
            </p>
          </div>

          {/* Contact */}
          <div data-id="element-87" data-mp="1rgsiaiq1teef">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white/90" data-id="element-88" data-mp="3ob53hu28ul0w">
              Get in Touch
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-white/60" data-id="element-89" data-mp="3tb9mbqqmjrua">
              <li className="flex items-start gap-2" data-id="element-90" data-mp="2aevebtv95q6b">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-91" data-mp="2agolda9s2ceu" />
                Manhattan · Queens · Long Island
              </li>
              <li className="flex items-start gap-2" data-id="element-92" data-mp="21mjyt31ofn54">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-93" data-mp="21n1unykffzci" />
                <a href="mailto:allycleaningservices1@gmail.com" className="break-all hover:text-white transition-colors" data-id="element-94" data-mp="1wp0atbf6fvzz">
                  Email: allycleaningservices1@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-95" data-mp="2kcry1a299tg1">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-96" data-mp="2kfe6dbwz0czb" />
                <a href="sms:+19296509940" className="hover:text-white transition-colors" data-id="element-97" data-mp="2fdotdqq6tp8l">
                  Text/Call: (929) 650-9940
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-98" data-mp="1414ei7tis63q">
                <InstagramIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-99" data-mp="2ruogv85vonzy" />
                <a href="https://www.instagram.com/ally.cleaningservices" target="_blank" rel="noreferrer" className="hover:text-white transition-colors" data-id="element-100" data-mp="2wmzeg4d5bxpc">
                  Instagram: @ally.cleaningservices
                </a>
              </li>
            </ul>
            <a href="#quote" className="mt-5 inline-flex rounded-full bg-magenta px-5 py-2.5 text-sm font-semibold text-white hover:bg-magenta-dark transition-colors" data-id="element-101" data-mp="3bhm61klsvq9e">
              Book Now
            </a>
          </div>

          <div data-id="element-102" data-mp="36jkox57xq10k">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white/90" data-id="element-103" data-mp="36j2hdcfto0dc">
              Our Service Areas
            </h3>
            <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 p-5" data-id="element-104" data-mp="1v574698ha1or">
              <p className="text-sm leading-relaxed text-white/60" data-id="element-105" data-mp="1v346r44zx6a0">
                Trusted boutique cleaning for homes and offices across:
              </p>
              <ul className="mt-4 space-y-3 text-sm font-medium text-white/85" data-id="element-106" data-mp="1im33ibcabbe4">
                {['Manhattan', 'Queens', 'Long Island'].map(area => <li key={area} className="flex items-center gap-2" data-id="element-107" data-mp="1rnsu5eyce6au">
                    <MapPinIcon className="h-4 w-4 text-sky-brand" data-id="element-108" data-mp="1rlgdd54bm1zd" />
                    {area}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center gap-3 border-t border-white/10 pt-6 text-center text-xs text-white/40 sm:mt-14 sm:flex-row sm:justify-between" data-id="element-109" data-mp="zuac2lcv5y8i">
          <p data-id="element-110" data-mp="18w9tvfvpd6ci">
            © {new Date().getFullYear()} Ally Cleaning Boutique NYC. All rights
            reserved.
          </p>
          <nav aria-label="Legal" className="flex items-center gap-4" data-id="element-111" data-mp="l5e7iya0n3cn">
            <a href="#terms" className="transition-colors hover:text-white" data-id="element-112" data-mp="g7urptxo6iil">
              Terms &amp; Conditions
            </a>
            <a href="#privacy" className="transition-colors hover:text-white" data-id="element-113" data-mp="2g8sxxhr5tdaf">
              Privacy Policy
            </a>
          </nav>
        </div>
      </div>
    </footer>;
}